mainApp.component('inputWithDefault', {
    transclude: true,
    templateUrl: '/public/components/input-with-default.component.html',
    bindings: {
        label: '<',
        useDefault: '<',
        onDefaultChange: '&',
        disabled: '<?',
        model: '<?',
    },
    controller: function() {

        const ctrl = this;

        ctrl.name = "radio" + new Date().getTime();

        ctrl.onChange = function() {
            ctrl.onDefaultChange({useDefault: ctrl.useDefault, model: ctrl.model});
        }

        ctrl.$onChanges = function(changes) {
            if(changes.label && changes.label.currentValue) {
                ctrl.defaultLabel = changes.label.currentValue;
            }
        }

    }
});